<div [style.color]="color ? color : 'inherit'">
  {{ value }}
</div>
